import { useSelector } from 'react-redux';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { useCompanyId } from 'src/core/modules/app/hooks/useCompanyId';

import { useCompanyCurrency } from '../../../app/hooks/useCompanyCurrency';
import { selectors } from '../redux';
import { useQuotes } from './api';
import { useIsIwtEnabled } from './api/useIsIwtEnabled';

export function useCanConfirmInternationalPayments() {
  const { t } = useTranslation('global');

  const companyId = useCompanyId();

  const companyCurrency = useCompanyCurrency();

  const isIwtEnabled = useIsIwtEnabled();

  const selectedTransfers = useSelector(selectors.selectTransfersByType(false));

  const { hasError } = useQuotes({
    companyId,
    selectedTransfers,
    companyCurrency,
  });

  if (isIwtEnabled && hasError) {
    return {
      canConfirmPayments: false,
      reason: t('international-wiretransfer.errors.missingQuotes'),
    };
  }

  return {
    canConfirmPayments: true,
  };
}
